import { render, staticRenderFns } from "./instIndex.vue?vue&type=template&id=3df82e3c"
import script from "./instIndex.vue?vue&type=script&lang=js"
export * from "./instIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports